import { CampaignsApi } from '../clients';

/**
 * Remove an applied promo code from an office.
 *
 * @param {string} officeId - The office's id
 * @param {string} campaignId - The campaign (UUID) whose application to take back
 * @returns {Promise<void>} No content response
 */
export const removeOfficePromoCode = async (officeId, campaignId) => {
  await CampaignsApi.removeOfficePromoCode(officeId, campaignId);
};
